import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";
import type {
  SendSupportRequestInput,
  SendSupportRequestResponse,
} from "@event-planner/shared";

const sendSupportRequestCallable = httpsCallable<
  SendSupportRequestInput,
  SendSupportRequestResponse
>(functions, "sendSupportRequest");

export async function sendSupportRequest(
  input: SendSupportRequestInput,
): Promise<SendSupportRequestResponse> {
  const result = await sendSupportRequestCallable(input);
  return result.data;
}
